import { useState } from 'react';

export const useModal = (defaultIsOpen?: boolean) => {
  const [isOpen, setIsOpen] = useState<boolean>(defaultIsOpen || false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return { isOpen, openModal, closeModal };
};
